<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header [urlName]="'Cep'" urlPath="cep"></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar/Incluir Cep</h1>

            <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                <div class="sm:col-span-4 flex items-end gap-1">
                    <app-input-cep
                        id="cep"
                        label="Cep"
                        formControlName="Cep"
                        (onBlur)="verificaCepValido($event)"
                        (onKeypress)="verificaCepValido($event)"
                        class="flex-1 min-w-0"
                    ></app-input-cep>

                    <app-button
                        icon="fa fa-search"
                        class="w-12 h-8 shrink-0"
                        (click)="verificaCepValido({ type: 'blur' })"
                    ></app-button>
                </div>

                <app-input
                    id="endereco"
                    label="Endereço"
                    formControlName="Logradouro"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="bairro"
                    label="Bairro"
                    formControlName="Bairro"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="complemento"
                    label="Complemento"
                    formControlName="Complemento"
                    class="sm:col-span-8"
                ></app-input>

                <app-select
                    [icon]="true"
                    label="Estado"
                    formControlName="Uf"
                    [options]="selectEstado"
                    class="sm:col-span-4"
                ></app-select>

                <app-input
                    id="cidade"
                    label="Cidade"
                    formControlName="Cidade"
                    class="sm:col-span-8"
                ></app-input>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
